import {
  Button,
  Icon,
  IconName,
  MenuButton,
  MenuButtonProps
} from '../../../atoms';

export function TagMultiSelectButton({
  isOpen,
  ...rest
}: MenuButtonProps & { isOpen: boolean }): JSX.Element {
  return (
    <MenuButton
      as={Button}
      backgroundColor="transparent"
      borderColor="palette_gray.5"
      outline="none"
      flexGrow={1}
      minHeight="48px"
      h="auto"
      paddingX="space_unit.x2"
      paddingY="space_unit.x1"
      borderRadius="radii.x1"
      _focusVisible={{
        borderColor: 'palette_blue.5',
        borderWidth: '3px',
        borderStyle: 'solid'
      }}
      w="100%"
      _hover={{
        color: 'transparent',
        borderColor: 'palette_gray.40'
      }}
      _disabled={{
        color: 'palette_gray.60',
        backgroundColor: 'palette_gray.5'
      }}
      rightIcon={
        <Icon
          name={isOpen ? IconName.ArrowUp : IconName.ArrowDown}
          width="12px"
          height="12px"
          marginLeft={2}
          color="palette_gray.100"
        />
      }
      {...rest}
    />
  );
}
